<template>
  <div class="login_wrap">
    <div>
      <div class="title">
        <div>{{ language("resetPass.title") }}</div>
        <div>{{ language("resetPass.subTitle") }}</div>
      </div>
      <div class="login_form">
        <el-form
          :model="form"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="200px"
          class="demo-ruleForm"
          label-position="left"
        >
          <el-form-item
            :label="language('resetPass.loginName')"
            prop="username"
          >
            <el-input v-model="form.username"></el-input>
            <!-- {{ form.username }} -->
          </el-form-item>

          <el-form-item
            :label="language('resetPass.oldPassword')"
            prop="oldPassword"
          >
            <el-input
              v-model="form.oldPassword"
              type="password"
              autocomplete="off"
            ></el-input>
          </el-form-item>

          <el-form-item :label="language('resetPass.password')" prop="password">
            <el-input
              v-model="form.password"
              type="password"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="language('resetPass.password2')"
            prop="password2"
          >
            <el-input
              v-model="form.password2"
              type="password"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">{{
              language("resetPass.submit")
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        password2: "",
        password: "",
        oldPassword: "",
      },
      rules: {
        username: [
          {
            required: true,
            message: this.language("resetPass.usernameRules"),
            trigger: "change",
          },
        ],
        oldPassword: [
          {
            trigger: "blur",
            required: true,
            message: this.language("resetPass.oldPasswordRules"),
          },
        ],
        password: [
          {
            validator: this.validatePass,
            trigger: "change",
            required: true,
          },
        ],
        password2: [
          {
            validator: this.validatePass2,
            trigger: "change",
            required: true,
          },
        ],
      },
    };
  },
  methods: {
    validatePass2(rule, value, callback) {
      if (this.form.password2 == "") {
        callback(new Error(this.language("accountManagement.validatePass")[0]));
      } else if (this.form.password !== this.form.password2) {
        callback(new Error(this.language("accountManagement.validatePass")[1]));
      } else {
        callback();
      }
    },
    validatePass(rule, value, callback) {
      if (this.form.password == "") {
        callback(new Error(this.language("accountManagement.validatePass")[0]));
      } else if (this.form.password) {
        var r = /^[A-Za-z0-9_]*$/;
        if (!r.test(this.form.password)) {
          callback(new Error(this.language("accountManagement.format")));
        } else if (this.form.password.length < 5) {
          callback(new Error(this.language("accountManagement.passMin")));
        }
        callback();
      } else if (
        this.form.password2 &&
        this.form.password !== this.form.password2
      ) {
        callback(new Error(this.language("accountManagement.validatePass")[1]));
      } else {
        callback();
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let form = {
            account: this.form.username,
            newPassword: this.form.password,
            oldPassword: this.form.oldPassword,
            rePassword: this.form.password2,
            userId: 120,
          };
          this.ccRequest
            .do("admin/merchant/user/changePassword", form, "POSTJSON")
            .then((res) => {
              this.$message.success(this.language("resetPass.success"));
              this.storage.delStorage("resetKey");
              this.$router.push({ path: "/login" });
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    if (localStorage.getItem(process.env.VUE_APP_resetKey)) {
      try {
        let data = JSON.parse(
          window.atob(
            window.atob(
              localStorage.getItem(process.env.VUE_APP_resetKey).substring(5)
            )
          )
        );
        this.form = { ...data, password2: "", password: "" };
      } catch (error) {}
    }
  },
};
</script>
<style lang="scss">
.login_wrap {
  .el-form-item__label {
    font-weight: 600;
  }
}
</style>
<style scoped lang="scss">
.login_wrap {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.title {
  padding: 0 0 20px 0;
  margin: 0 auto;
  color: $mainColor;
  font-weight: 600;
  border-bottom: 1px solid #259b24;
  width: 620px;
  div {
    text-align: center;
    font-size: 36px;
  }
}
.login_form {
  margin: 50px auto 0 auto;
  width: 550px;
}
</style>